import { NotificationPreferenceSection } from "@/Apollo/schema";

/** WHO-5616: the page, its menu item and the one-click route stay hidden until this gate is on. */
export const NOTIFICATION_PREFERENCES_GATE = "notification_preferences";

export const NOTIFICATION_PREFERENCES_NAMESPACE = "account";

/** Section order on the page, with English fallbacks next to their Lokalise keys. */
export const NOTIFICATION_PREFERENCE_SECTIONS: {
  section: NotificationPreferenceSection;
  key: string;
  fallback: string;
}[] = [
  {
    section: NotificationPreferenceSection.UserActions,
    key: "account:notification-preferences-section-user-actions",
    fallback: "About your favourites and searches",
  },
  {
    section: NotificationPreferenceSection.WhoppahActions,
    key: "account:notification-preferences-section-whoppah-actions",
    fallback: "From Whoppah",
  },
  {
    section: NotificationPreferenceSection.Transactional,
    key: "account:notification-preferences-section-transactional",
    fallback: "About your buying and selling",
  },
];

/** Label per message-type key. A key the server adds later falls back to a humanised key. */
export const NOTIFICATION_PREFERENCE_LABELS: Record<
  string,
  { key: string; fallback: string }
> = {
  FAVORITE_SOLD: {
    key: "account:notification-preferences-favorite-sold",
    fallback: "A favourite is sold",
  },
  FAVORITE_PRICE_DROP: {
    key: "account:notification-preferences-favorite-price-drop",
    fallback: "A favourite drops in price",
  },
  SAVED_SEARCH: {
    key: "account:notification-preferences-saved-search",
    fallback: "New items for your saved searches",
  },
  ABANDONED_CART: {
    key: "account:notification-preferences-abandoned-cart",
    fallback: "Items left in your cart",
  },
  NEWSLETTER: {
    key: "account:notification-preferences-newsletter",
    fallback: "Newsletter",
  },
  DISCOUNTS_CAMPAIGNS: {
    key: "account:notification-preferences-discounts-campaigns",
    fallback: "Discounts and campaigns",
  },
  WHOPPAH_UPDATES: {
    key: "account:notification-preferences-whoppah-updates",
    fallback: "Whoppah updates",
  },
  NEW_MESSAGE: {
    key: "account:notification-preferences-new-message",
    fallback: "New messages",
  },
  NEW_FAVORITE_ON_LISTING: {
    key: "account:notification-preferences-new-favorite-on-listing",
    fallback: "Someone saved your listing",
  },
  BIDDING: {
    key: "account:notification-preferences-bidding",
    fallback: "Bids and offers",
  },
  LISTING_UPDATES: {
    key: "account:notification-preferences-listing-updates",
    fallback: "Listing updates",
  },
  CURATION_UPDATES: {
    key: "account:notification-preferences-curation-updates",
    fallback: "Curation updates",
  },
  REVIEWS: {
    key: "account:notification-preferences-reviews",
    fallback: "Reviews",
  },
  ORDER_UPDATES: {
    key: "account:notification-preferences-order-updates",
    fallback: "Order updates",
  },
  SHIPPING_UPDATES: {
    key: "account:notification-preferences-shipping-updates",
    fallback: "Shipping updates",
  },
  PAYOUT_UPDATES: {
    key: "account:notification-preferences-payout-updates",
    fallback: "Payout updates",
  },
  ACCOUNT_UPDATES: {
    key: "account:notification-preferences-account-updates",
    fallback: "Account updates",
  },
  LEGAL_POLICY_UPDATES: {
    key: "account:notification-preferences-legal-policy-updates",
    fallback: "Legal and policy updates",
  },
};

/** "SOME_NEW_TYPE" -> "Some new type", for a key this build has no label for. */
export const humaniseNotificationKey = (key: string) => {
  const words = key.toLowerCase().split("_").filter(Boolean).join(" ");

  return words.charAt(0).toUpperCase() + words.slice(1);
};
